import { z } from "zod";

const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const videoSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Ce champs est obligatoire" }),

  thumbnail: z
    .string({ required_error: "Le lien du miniature est obligatoire" })
    .min(3, { message: "Ce champs est obligatoire" }),

  url: z
    .string({ required_error: "Le lien youtube est obligatoire" })
    .min(3, { message: "Ce champs est obligatoire" }),
});

export type VideoFormValues = z.infer<typeof videoSchema>;

export const updateVideoSchema = z
  .object({
    image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          const invalidImages = images.filter((img) => {
            const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
            return (
              fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
            );
          });
          return invalidImages.length === 0;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      ),
  })
  .partial();

export type UpdateVideoFormValues = z.infer<typeof updateVideoSchema>;
